const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCursos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3436 660",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 77.74,
    y: 372.474,
    width: 3357.975,
    height: 55.704,
    style: {
      fill: "#127475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.996,470.871c-38.962,0 -70.546,-31.583 -70.546,-70.546c-0,-38.962 31.583,-70.55 70.546,-70.55c38.962,0 70.546,31.587 70.546,70.55c0,38.962 -31.583,70.546 -70.546,70.546",
    style: {
      fill: "#f5dfbb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M421.459,625.054l19.5,0l0,-42.75l23.55,0c20.1,0 36.3,-13.2 36.3,-36.45c0,-23.1 -16.35,-36.3 -36.3,-36.3l-43.05,0l0,115.5Zm19.5,-62.25l0,-33.75l23.55,0c9.3,0 16.8,6 16.8,16.8c0,10.95 -7.5,16.95 -16.8,16.95l-23.55,0Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.559,626.554c11.25,0 19.8,-4.2 25.5,-11.25l0.45,9.75l18.15,0l0,-75.6l-19.5,0l0,8.55c-5.55,-6.45 -13.8,-10.35 -24.6,-10.35c-20.4,0 -37.35,17.55 -37.35,39.45c0,22.05 16.95,39.45 37.35,39.45Zm3.75,-17.7c-12.15,0 -21.6,-9.75 -21.6,-21.75c0,-12 9.45,-21.6 21.6,-21.6c12,0 21.45,9.6 21.45,21.6c0,12 -9.45,21.75 -21.45,21.75Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.509,567.154l0,-19.05c-0.9,-0.15 -1.8,-0.15 -2.7,-0.15c-9.6,0 -15.9,4.5 -20.4,12.15l0,-10.65l-19.35,0l0,75.6l19.35,0l0,-33.45c0,-22.05 11.55,-26.7 23.1,-24.45Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.609,626.554c11.25,0 19.8,-4.2 25.5,-11.25l0.45,9.75l18.15,0l0,-75.6l-19.5,0l0,8.55c-5.55,-6.45 -13.8,-10.35 -24.6,-10.35c-20.4,0 -37.35,17.55 -37.35,39.45c0,22.05 16.95,39.45 37.35,39.45Zm3.75,-17.7c-12.15,0 -21.6,-9.75 -21.6,-21.75c0,-12 9.45,-21.6 21.6,-21.6c12,0 21.45,9.6 21.45,21.6c0,12 -9.45,21.75 -21.45,21.75Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.109,659.554l19.5,0l0,-42.6c6,6 14.1,9.6 24,9.6c20.4,0 37.2,-17.4 37.2,-39.3c0,-21.9 -16.8,-39.3 -37.2,-39.3c-9.9,0 -18,3.6 -24,9.6l0,-8.1l-19.5,0l0,110.1Zm39.9,-50.7c-11.85,0 -21.6,-9.6 -21.6,-21.6c0,-12 9.75,-21.6 21.6,-21.6c11.85,0 21.45,9.6 21.45,21.6c0,12 -9.6,21.6 -21.45,21.6Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.309,586.504c-0.3,-23.1 -17.1,-38.55 -38.85,-38.55c-23.1,0 -39.9,17.4 -39.9,39.3c0,21.9 16.5,39.3 40.5,39.3c15.9,0 28.65,-7.8 34.8,-20.25l-15.6,-6.45c-4.05,7.05 -11.4,10.95 -19.35,10.95c-11.1,0 -19.8,-7.8 -21.3,-20.1l59.55,0l0.15,-4.2Zm-38.7,-23.1c8.85,0 14.85,4.8 18,12.45l-37.05,0c3.3,-7.65 9.9,-12.45 19.05,-12.45Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.059,567.154l0,-19.05c-0.9,-0.15 -1.8,-0.15 -2.7,-0.15c-9.6,0 -15.9,4.5 -20.4,12.15l0,-10.65l-19.35,0l0,75.6l19.35,0l0,-33.45c0,-22.05 11.55,-26.7 23.1,-24.45Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.459,626.554c16.5,0 28.35,-8.4 28.35,-23.7c0,-15.15 -11.4,-20.25 -22.65,-24c-8.85,-2.85 -14.25,-4.35 -14.25,-9.45c0,-3.9 3.15,-6.45 7.95,-6.45c5.1,0 10.8,3 15.15,7.35l11.4,-11.55c-5.85,-6.45 -15,-10.8 -25.95,-10.8c-14.55,0 -27.75,7.8 -27.75,23.1c0,13.2 9.9,18.45 21.6,22.65c9,3.15 15.15,4.5 15.15,9.75c0,4.05 -3.6,7.2 -9.6,7.2c-5.85,0 -12.9,-3.3 -18.15,-8.7l-10.95,13.35c6,6 16.65,11.25 29.7,11.25Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.309,626.554c22.5,0 39.9,-17.4 39.9,-39.3c0,-21.9 -17.4,-39.3 -39.9,-39.3c-22.8,0 -40.05,17.4 -40.05,39.3c0,21.9 17.25,39.3 40.05,39.3Zm0,-18c-12,0 -21.45,-9.45 -21.45,-21.3c0,-11.85 9.45,-21.15 21.45,-21.15c11.55,0 21,9.3 21,21.15c0,11.85 -9.45,21.3 -21,21.3Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.509,625.054l19.35,0l0,-46.5c0.15,-7.65 6.15,-13.5 14.25,-13.5c7.65,0 13.65,5.55 13.65,13.5l0,46.5l19.5,0l0,-48.9c0,-15.75 -12,-28.2 -27.15,-28.2c-7.65,0 -14.85,3 -20.25,8.4l0,-6.9l-19.35,0l0,75.6Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.959,626.554c11.25,0 19.8,-4.2 25.5,-11.25l0.45,9.75l18.15,0l0,-75.6l-19.5,0l0,8.55c-5.55,-6.45 -13.8,-10.35 -24.6,-10.35c-20.4,0 -37.35,17.55 -37.35,39.45c0,22.05 16.95,39.45 37.35,39.45Zm3.75,-17.7c-12.15,0 -21.6,-9.75 -21.6,-21.75c0,-12 9.45,-21.6 21.6,-21.6c12,0 21.45,9.6 21.45,21.6c0,12 -9.45,21.75 -21.45,21.75Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.309,626.554c16.5,0 28.35,-8.4 28.35,-23.7c0,-15.15 -11.4,-20.25 -22.65,-24c-8.85,-2.85 -14.25,-4.35 -14.25,-9.45c0,-3.9 3.15,-6.45 7.95,-6.45c5.1,0 10.8,3 15.15,7.35l11.4,-11.55c-5.85,-6.45 -15,-10.8 -25.95,-10.8c-14.55,0 -27.75,7.8 -27.75,23.1c0,13.2 9.9,18.45 21.6,22.65c9,3.15 15.15,4.5 15.15,9.75c0,4.05 -3.6,7.2 -9.6,7.2c-5.85,0 -12.9,-3.3 -18.15,-8.7l-10.95,13.35c6,6 16.65,11.25 29.7,11.25Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M561.659,263.333c21.667,0 40.667,-5 59.667,-15l0,-54c-18.333,17 -35,25 -60.667,25c-50,0 -88.333,-39 -88.333,-87.667c0,-49.333 39.333,-87.667 88.667,-87.667c24,0 41.333,7.667 60.333,24.667l0,-53.667c-19,-10 -38,-15 -59.667,-15c-73.667,0 -133.333,57.667 -133.333,131.333c0,73.333 59,132 133.333,132Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.993,263.333c46,0 73,-26 73,-66.333l0,-105l-43.333,0l0,104.667c0,19.333 -12.667,29 -29.667,29c-16.667,0 -29.333,-9.667 -29.333,-29l0,-104.667l-43.333,0l0,105c0,40.333 27,66.333 72.667,66.333Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.993,131.333l0,-42.333c-2,-0.333 -4,-0.333 -6,-0.333c-21.333,0 -35.333,10 -45.333,27l0,-23.667l-43,0l0,168l43,0l0,-74.333c0,-49 25.667,-59.333 51.333,-54.333Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.326,263.333c36.667,0 63,-18.667 63,-52.667c0,-33.667 -25.333,-45 -50.333,-53.333c-19.667,-6.333 -31.667,-9.667 -31.667,-21c0,-8.667 7,-14.333 17.667,-14.333c11.333,0 24,6.667 33.667,16.333l25.333,-25.667c-13,-14.333 -33.333,-24 -57.667,-24c-32.333,0 -61.667,17.333 -61.667,51.333c0,29.333 22,41 48,50.333c20,7 33.667,10 33.667,21.667c0,9 -8,16 -21.333,16c-13,0 -28.667,-7.333 -40.333,-19.333l-24.333,29.667c13.333,13.333 37,25 66,25Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.326,263.333c50,0 88.667,-38.667 88.667,-87.333c0,-48.667 -38.667,-87.333 -88.667,-87.333c-50.667,0 -89,38.667 -89,87.333c0,48.667 38.333,87.333 89,87.333Zm0,-40c-26.667,0 -47.667,-21 -47.667,-47.333c0,-26.333 21,-47 47.667,-47c25.667,0 46.667,20.667 46.667,47c0,26.333 -21,47.333 -46.667,47.333Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.659,263.333c36.667,0 63,-18.667 63,-52.667c0,-33.667 -25.333,-45 -50.333,-53.333c-19.667,-6.333 -31.667,-9.667 -31.667,-21c0,-8.667 7,-14.333 17.667,-14.333c11.333,0 24,6.667 33.667,16.333l25.333,-25.667c-13,-14.333 -33.333,-24 -57.667,-24c-32.333,0 -61.667,17.333 -61.667,51.333c0,29.333 22,41 48,50.333c20,7 33.667,10 33.667,21.667c0,9 -8,16 -21.333,16c-13,0 -28.667,-7.333 -40.333,-19.333l-24.333,29.667c13.333,13.333 37,25 66,25Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.996,296.212c-57.4,0 -104.112,46.696 -104.112,104.112c0,57.412 46.696,104.112 104.112,104.112c57.417,0 104.112,-46.7 104.112,-104.112c0,-57.417 -46.696,-104.112 -104.112,-104.112m0,241.104c-75.537,0 -136.996,-61.458 -136.996,-136.992c-0,-75.537 61.458,-136.996 136.996,-136.996c75.537,0 136.992,61.458 136.992,136.996c0,75.533 -61.454,136.992 -136.992,136.992",
    style: {
      fill: "#f5dfbb",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursos);
export default __webpack_public_path__ + "static/media/cursos.c3af286f9b2579d49629f21f31534416.svg";
export { ForwardRef as ReactComponent };